const userKeys = {
  register: (id: string) => ["register", id] as const,
};

export { userKeys };
